import React, { useEffect, useState } from 'react';
import useAxios from '../utils/useAxios';

const HeuresTravaillees = () => {
  const [heures, setHeures] = useState({ jour: 0, semaine: 0, mois: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const api = useAxios();

  const styles = {
    pageContainer: {
      minHeight: '100vh',
      padding: '40px',
      backgroundColor: '#f8f9fa',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    card: {
      width: '100%',
      maxWidth: '800px',
      padding: '40px',
      backgroundColor: 'white',
      borderRadius: '16px',
      boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
      textAlign: 'center'
    },
    header: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: '40px'
    },
    clockIcon: {
      fontSize: '48px',
      marginRight: '20px',
      color: '#4a6baf'
    },
    title: {
      fontSize: '32px',
      fontWeight: '600',
      color: '#2c3e50',
      margin: 0
    },
    listContainer: {
      display: 'flex',
      justifyContent: 'space-around',
      flexWrap: 'wrap',
      gap: '30px'
    },
    timeBlock: {
      backgroundColor: '#f1f5fe',
      borderRadius: '12px',
      padding: '25px',
      minWidth: '200px',
      flex: 1
    },
    timeLabel: {
      fontSize: '18px',
      color: '#5a6d8a',
      marginBottom: '15px'
    },
    timeValue: {
      fontSize: '36px',
      fontWeight: '700',
      color: '#3a5cb2',
      margin: 0
    },
    spinner: {
      border: '5px solid #f3f3f3',
      borderTop: '5px solid #4a6baf',
      borderRadius: '50%',
      width: '50px',
      height: '50px',
      animation: 'spin 1s linear infinite',
      margin: '0 auto 30px'
    },
    loadingText: {
      fontSize: '20px',
      color: '#5a6d8a'
    },
    error: {
      color: '#e74c3c',
      fontSize: '18px',
      backgroundColor: '#fdecea',
      padding: '15px',
      borderRadius: '8px',
      maxWidth: '500px',
      margin: '0 auto'
    },
    refreshInfo: {
      marginTop: '30px',
      color: '#7f8c8d',
      fontSize: '14px'
    }
  };

  const formatHeures = (hours) => {
    const heures = Math.floor(hours);
    const minutes = Math.round((hours - heures) * 60);
    return minutes > 0 ? `${heures}h${minutes.toString().padStart(2, '0')}` : `${heures}h`;
  };

  const fetchHeures = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await api.get('/pointage/heures-travaillees/');
      setHeures(response.data);
    } catch (error) {
      console.error('Erreur lors du chargement des heures travaillées', error);
      setError("Impossible de charger les données. Veuillez réessayer plus tard.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHeures();
    const interval = setInterval(fetchHeures, 300000);
    return () => clearInterval(interval);
  }, []);

  if (loading) {
    return (
      <div style={styles.pageContainer}>
        <div style={styles.card}>
          <div style={styles.spinner}></div>
          <p style={styles.loadingText}>Chargement de vos heures...</p>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.pageContainer}>
      <div style={styles.card}>
        <div style={styles.header}>
          <span style={styles.clockIcon}>⏱️</span>
          <h1 style={styles.title}>Vos heures travaillées</h1>
        </div>

        {error ? (
          <div>
            <p style={styles.error}>{error}</p>
          </div>
        ) : (
          <div>
            <div style={styles.listContainer}>
              <div style={styles.timeBlock}>
                <p style={styles.timeLabel}>Aujourd'hui</p>
                <h2 style={styles.timeValue}>{formatHeures(heures.jour)}</h2>
              </div>
              
              <div style={styles.timeBlock}>
                <p style={styles.timeLabel}>Cette semaine</p>
                <h2 style={styles.timeValue}>{formatHeures(heures.semaine)}</h2>
              </div>
              
              <div style={styles.timeBlock}>
                <p style={styles.timeLabel}>Ce mois</p>
                <h2 style={styles.timeValue}>{formatHeures(heures.mois)}</h2>
              </div>
            </div>
            
            <p style={styles.refreshInfo}>
              Les données sont actualisées automatiquement toutes les 5 minutes
            </p>
          </div>
        )}
      </div>
      
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default HeuresTravaillees;